var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-section-state home-section-state--error",attrs:{"role":"status"}},[_c('p',[_vm._v(_vm._s(_vm.message))]),(_vm.retryable)?_c('button',{staticClass:"home-state-retry",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('retry')}}},[_vm._v("Tentar novamente")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }